function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.14924 0.476109C8.84441 0.171263 8.43095 0 7.99984 0C7.56872 0 7.15526 0.171263 6.85043 0.476109L0.479805 6.84713L0.471632 6.85546C0.0190598 7.31146 -0.122334 7.99129 0.110894 8.58992C0.344121 9.18854 0.908173 9.59355 1.54996 9.62321C1.56903 9.62481 1.58826 9.62562 1.60717 9.62562H1.67432V14.1285C1.67502 15.1614 2.51211 15.9987 3.54509 15.9997H6.0386C6.39444 15.9994 6.68292 15.7112 6.68345 15.3553V11.6776C6.6838 11.3567 6.94382 11.0967 7.26468 11.0963H8.73563C9.05649 11.0967 9.31651 11.3567 9.31686 11.6776V15.3553C9.31721 15.7112 9.60564 15.9996 9.96155 16H12.4551C13.4879 15.999 14.3249 15.1621 14.326 14.1293V9.62642H14.3741C15.0309 9.62647 15.6232 9.23132 15.8754 8.62486C16.1275 8.01841 15.99 7.3198 15.5268 6.85418L9.14924 0.476109Z",
  fill: "#99A6B0"
});

const SvgXSmallGray = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgXSmallGray, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/xSmall-gray.978a1caf.svg";
export { ForwardRef as ReactComponent };